import { render, staticRenderFns } from "./ReceiptRating.vue?vue&type=template&id=a00a63a0&scoped=true&"
import script from "./ReceiptRating.vue?vue&type=script&lang=js&"
export * from "./ReceiptRating.vue?vue&type=script&lang=js&"
import style0 from "./ReceiptRating.vue?vue&type=style&index=0&id=a00a63a0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a00a63a0",
  null
  
)

export default component.exports